import { render, staticRenderFns } from "./BackDetail.vue?vue&type=template&id=137c1750&scoped=true"
import script from "./BackDetail.vue?vue&type=script&lang=ts"
export * from "./BackDetail.vue?vue&type=script&lang=ts"
import style0 from "./BackDetail.vue?vue&type=style&index=0&id=137c1750&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c1750",
  null
  
)

export default component.exports